import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: {
    jotaiStore: undefined!,
    queryClient: undefined!,
  },
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})
